import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { typeScale } from '@/shared/styles/typography'

const baseSx = {
  flex: 1,
  minWidth: 0,
  fontSize: typeScale.body.fontSize,
  lineHeight: typeScale.body.lineHeight,
  color: colorTokens.fg.default,
  px: 1.25,
  py: 0.75,
  borderRadius: `${RADIUS.sm}px`,
  transition: 'background-color 120ms, box-shadow 120ms',
} as const

// 本文に置く 1 行の欄と select (在宅の患者の欄・栄養のお客様の欄)。design-book text-field §3:
// 白い地 = 打てる欄。地は白 + 内側 1px、hover で枠を濃く、focus で accent。
export const fieldInputSx = {
  ...baseSx,
  backgroundColor: colorTokens.bg.default,
  boxShadow: `inset 0 0 0 1px ${colorTokens.border.subtle}`,
  '&:hover': {
    boxShadow: `inset 0 0 0 1px ${colorTokens.border.default}`,
  },
  '&.Mui-focused': {
    boxShadow: `inset 0 0 0 1px ${colorTokens.accent.primary}`,
  },
} as const

// 本文の中の、1 欄で探す欄 (在宅の患者の登録・栄養のホーム)。design-book text-field §4:
// 地は subtle、hover で muted、focus で白 + 内側 1px。
export const searchInputSx = {
  ...baseSx,
  backgroundColor: colorTokens.bg.subtle,
  '&:hover': { backgroundColor: colorTokens.bg.muted },
  '&.Mui-focused': {
    backgroundColor: colorTokens.bg.default,
    boxShadow: `inset 0 0 0 1px ${colorTokens.border.default}`,
  },
} as const
